import { ItemAttributeResourceCalculationKeyBase } from './base/item-attribute-resource-calculation-key-base';

export class ItemAttributeResourceCalculationKey extends ItemAttributeResourceCalculationKeyBase { }